export default {
  getReasons(state) {
    return state.reasons;
  },
};
